import { useEffect } from 'react';
import useAuth from '../../hooks/auth/useAuth';

function Activation() {
    const { registrationActivate } = useAuth();

    useEffect(() => {
        registrationActivate();
    }, []);

    return (
        <div className="info-page h-100" />
    );
}

export default Activation;
